/* lp-bfa.js: reveal-on-scroll, photo rail arrows and AU to US geo routing for the Adventure Speaker page.
   Loaded with defer from every lp-bfa section; guarded so it only initialises once. */
(function () {
  if (window.__bfaInit) return;
  window.__bfaInit = true;
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Reveal: content is visible by default; the hidden start state only applies once this class is set.
  // Three layers so a section can never stay invisible: IntersectionObserver, a scroll-position check
  // (covers webviews that throttle the observer), and a safety reveal if the observer never reports.
  var items = Array.prototype.slice.call(document.querySelectorAll('.bfa [data-reveal]'));
  function showAll() { items.forEach(function (el) { el.classList.add('is-in'); }); }
  if (reduce || !('IntersectionObserver' in window) || !items.length) {
    showAll();
  } else {
    root.classList.add('bfa-js');
    var ioAlive = false;
    var io = new IntersectionObserver(function (entries) {
      ioAlive = true;
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    items.forEach(function (el) { io.observe(el); });
    var pending = false;
    function check() {
      pending = false;
      var limit = (window.innerHeight || document.documentElement.clientHeight) * 0.92;
      items.forEach(function (el) {
        if (!el.classList.contains('is-in') && el.getBoundingClientRect().top < limit) el.classList.add('is-in');
      });
    }
    function queue() { if (!pending) { pending = true; setTimeout(check, 80); } }
    window.addEventListener('scroll', queue, { passive: true, capture: true });
    window.addEventListener('resize', queue, { passive: true });
    window.addEventListener('load', check);
    check();
    setTimeout(function () { if (!ioAlive) showAll(); }, 2500);
  }

  // Rail arrows scroll one card at a time.
  document.querySelectorAll('[data-bfa-rail]').forEach(function (rail) {
    var track = rail.querySelector('.bfa-rail__track');
    if (!track) return;
    rail.querySelectorAll('[data-dir]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = track.querySelector('.bfa-card');
        var step = card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
        track.scrollBy({ left: step * Number(btn.getAttribute('data-dir')), behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  });

  // Geo routing: the AU page sends US visitors to the US store page, once per session.
  // Same-origin Cloudflare trace, so there is no third-party call. ?market=au keeps someone on AU.
  var geo = document.querySelector('[data-bfa-geo]');
  if (geo && geo.getAttribute('data-region') === 'au') {
    var target = geo.getAttribute('data-us-url');
    try {
      if (target && location.search.indexOf('market=au') === -1 && !sessionStorage.getItem('bfa_geo')) {
        fetch('/cdn-cgi/trace', { cache: 'no-store' })
          .then(function (r) { return r.text(); })
          .then(function (t) {
            sessionStorage.setItem('bfa_geo', '1');
            var m = /(?:^|\n)loc=([A-Z]{2})/.exec(t);
            if (m && m[1] === 'US') location.replace(target);
          })
          .catch(function () {});
      }
    } catch (err) { /* storage blocked: stay on AU, which works for everyone */ }
  }
})();
